import { connect } from 'react-redux'
import * as action from '../../state/reassign/action'
import * as selector from '../../state/reassign/selector'
import Reassign from './Reassign'
import { selectPhysicianList, selectTreatingPhysicianList } from '../../../globals/state/selector'


const mapStateToProps = state => {
    return {
        reassignment: selector.selectReassignment(state),
        isReassignmentTreatingPhysician: selector.selectIsReassignmentTreatingPhysician(state),
        isReassignmentPartnerPhysician: selector.selectIsReassignmentPartnerPhysician(state),
        partnerPhysicianList: selectPhysicianList(state),
        treatingPhysicianList: selectTreatingPhysicianList(state),
        canProceed: selector.selectCanProceed(state),
        fetching: selector.selectIsFetching(state),
    }
}

const mapDispatchToProps = {
    changeReassignment: action.changeReassignment,
    reassignToPartnerPhysician: action.reassignToPartnerPhysician,
    reassignTreatingPhysician: action.reassignTreatingPhysician,

}


export default connect(mapStateToProps, mapDispatchToProps)(Reassign)



// WEBPACK FOOTER //
// ./src/modules/treatment/component/reassign/ReassignContainer.js